var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useTabsContext } from '../tabs-context';
import { styled } from '../../styled';
var Root = styled('div')({});
export var TabPanel = function (_a) {
    var value = _a.value, children = _a.children, rootProps = __rest(_a, ["value", "children"]);
    var _b = useTabsContext(), getTabPanelProps = _b.getTabPanelProps, isLazy = _b.isLazy, activeTabValue = _b.value;
    var isActive = activeTabValue === value;
    var shouldRenderChildren = !isLazy || isActive;
    return (React.createElement(Root, __assign({}, rootProps, getTabPanelProps(value)), shouldRenderChildren && children));
};
